export function singleObjectParamMemoize(fn) {
    function memoized(param) {
        if (!memoized._cache) {
            memoized._cache = new WeakMap();
        }
        const cache = memoized._cache;
        if (!cache.has(param)) {
            const ret = fn(param);
            cache.set(param, ret);
        }
        return cache.get(param);
    }
    return memoized;
}
//# sourceMappingURL=cache.js.map